import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import MobileButton from "../../Mobile/Buttons/MobileButton";
import "./Welcome.css";
import "../Login/Login.css"; // Reuse shared layout styles

/**
 * Premium Welcome view after user registration.
 * Integrated into the unified AuthLayout.
 */
const Welcome = () => {
    const navigate = useNavigate();

    return (
        <div className="mobile-login-body-inner text-center">
            <div className="d-flex flex-column align-items-center gap-4 w-100">
                {/* Title Section */}
                <div className="animate-fade-in-up w-100">
                    <h1 className="auth-main-title">
                        Bienvenido al futuro del entrenamiento con <span className="welcome-highlight">Elevva</span>
                    </h1>
                    <div className="welcome-decorator-container">
                        <div className="recover-accent-line mx-auto"></div>
                    </div>
                </div>

                {/* Description */}
                <p className="mobile-login-description mb-0 animate-fade-in-up delay-1 px-2">
                    Tu experiencia de entrenamiento está a punto de dar un salto hacia la innovación. Con Elevva, accede a mediciones avanzadas y gestión inteligente.
                </p>

                {/* Features List */}
                <div className="welcome-features-list d-flex flex-column gap-3 animate-fade-in-up delay-1">
                    <div className="welcome-feature-item">
                        <div className="welcome-feature-icon">
                            <i className="bi bi-check-lg"></i>
                        </div>
                        <span className="welcome-feature-text">Mide, analiza y mejora cada sesión.</span>
                    </div>
                    <div className="welcome-feature-item">
                        <div className="welcome-feature-icon">
                            <i className="bi bi-check-lg"></i>
                        </div>
                        <span className="welcome-feature-text">Gestiona reservas y entrenamientos.</span>
                    </div>
                    <div className="welcome-feature-item">
                        <div className="welcome-feature-icon">
                            <i className="bi bi-check-lg"></i>
                        </div>
                        <span className="welcome-feature-text">Accede a reportes en tiempo real.</span>
                    </div>
                </div>

                {/* Footer Text */}
                <p className="welcome-footer-tagline mb-0 animate-fade-in-up delay-1">
                    ¡Transforma tu experiencia de entrenamiento hoy mismo!
                </p>

                <div className="animate-fade-in-up delay-1 pt-2 w-100">
                    <MobileButton
                        text="Empieza ahora"
                        onClick={() => navigate("/auth/complete-profile")}
                    />
                </div>
            </div>
        </div>
    );
};

export default memo(Welcome);
